module.exports = __webpack_public_path__ + "img/DE05741.f74e45d2.png";